const Events = () => {
    return(
        <>
            <div className="container">
                <h4 className="white-text">
                    <blocks>
                        Calendar of the Group
                    </blocks>
                </h4>
                <iframe 
                    className="google_calender"
                    src="https://calendar.google.com/calendar/embed?src=stringsntu%40gmail.com&ctz=Asia%2FTaipei"
                    width="800" 
                    height="600" 
                    frameborder="0" 
                    scrolling="no"
                    title="google_calendar"
                    
                />
                <h5 className="white-text">
                    • There are other "
                    <a className="events-event" href="https://phys.ncts.ntu.edu.tw/en/act/Seminars" target="_blank" rel="noopener noreferrer">
                        Events
                    </a>
                    " held or sponsored by National Center for Theoretical Sciences (NCTS)
                </h5>
                <br />
            </div>
        </>
    )
}

export default Events;